import { render, staticRenderFns } from "./Rm.vue?vue&type=template&id=b1778f68&scoped=true"
import script from "./Rm.vue?vue&type=script&lang=js"
export * from "./Rm.vue?vue&type=script&lang=js"
import style0 from "./Rm.vue?vue&type=style&index=0&id=b1778f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1778f68",
  null
  
)

export default component.exports